import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/*
 * WarningAlert Component
 * Purpose: Provides a generic, simple dialog box
 * Notes: Dependent components must provide title (alertTitle), body text
 *        (alertText), accept button caption (acceptCaption), reject button
 *        caption (rejectText), and event handlers. Also, the provideReject
 *        prop (a bool) indicates if there is a reject button (i.e. false if
 *        the dialog is to contain only 'OK' button.)
 */
export default function WarningAlert(props) {
  const { showAlert, toggleAlert, handleAlertAction, warning } = props;

  const handleClick_ok = (e) => {
    e.preventDefault();
    handleAlertAction();
  };

  return (
    <Modal isOpen={showAlert} toggle={toggleAlert} size={"md"} fade={false}>
      <ModalHeader className="bg-warning">
        <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
        Warning
      </ModalHeader>
      <ModalBody>{warning.message}</ModalBody>
      <ModalFooter className="bg-lightgray">
        <button
          name="warning_ok"
          id="warning_ok"
          onClick={handleClick_ok}
          className="btn btn-secondary"
        >
          OK
        </button>
      </ModalFooter>
    </Modal>
  );
}
